import type { FunctionComponent } from 'react';
import type * as T from './PageHeader.types';
import * as s from './PageHeader.css';
import Title from '@media-ui/core/src/components/Title';
import Text from '@media-ui/core/src/components/Text';
import Hr from '@media-ui/core/src/components/Hr';
import Breadcrumbs from '@media-ui/core/src/components/Breadcrumbs';
import classNames from 'classnames';
const PageHeader: FunctionComponent<T.IPageHeaderProps> = (props) => {
    const { title, description, breadcrumbs, children, descriptionProps, subtitle, titleSlot, } = props;
    const isBreadcrumbs = breadcrumbs && breadcrumbs.length > 0;
    return (<header className={s.root}>
      {isBreadcrumbs && (<Breadcrumbs className={s.breadcrumbs}>
          {breadcrumbs.map((breadcrumb) => (<Breadcrumbs.Item key={breadcrumb.href} {...breadcrumb}/>))}
        </Breadcrumbs>)}
      <div className={s.titleRow}>
        <div>
          <Title className={s.title} level="1">
            {title}
          </Title>
          {subtitle && <Text>{subtitle}</Text>}
        </div>

        {titleSlot && <div className={s.titleSlot}>{titleSlot}</div>}
      </div>

      {description && (<Text type="articleLead" {...descriptionProps} className={classNames(s.description, descriptionProps?.className)}>
          <div dangerouslySetInnerHTML={{ __html: description }}/>
        </Text>)}
      {children && <div>{children}</div>}
      <Hr type="dotted" separator/>
    </header>);
};
export default PageHeader;
